module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/recruitment-badge-5abdb78867a50af4706bacf5af1649b6.svg";